import React from "react";

function SessionTimeoutModal({ show, onStay, onLogout, countdown }) {
  if (!show) return null;

  return (
    <>
      {/* Backdrop */}
      <div className="modal-backdrop fade show"></div>

      {/* Modal */}
      <div className="modal fade show d-block" tabIndex="-1">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">

            <div className="modal-header">
              <h5 className="modal-title">Session Expiring</h5>
            </div>

            <div className="modal-body">
              <p>Your session is about to expire due to inactivity.</p>
              {countdown && (
                <p className="fw-bold text-danger mb-2">
                  Auto logout in {countdown}
                </p>
              )}
              <p>Do you want to stay logged in?</p>
            </div>

            <div className="modal-footer">
              <button
                className="btn btn-secondary"
                onClick={onLogout}
              >
                Logout
              </button>

              <button
                className="btn btn-primary"
                onClick={onStay}
              >
                Stay Logged In
              </button>
            </div>

          </div>
        </div>
      </div>
    </>
  );
}

export default SessionTimeoutModal;
